import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnChanges } from '@angular/core';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { Channel } from '@pixacare/chat';
import { TuiCell, TuiTitle } from '@taiga-ui/core';
import { TuiBadge, TuiLineClamp } from '@taiga-ui/kit';
import { Size } from 'src/app/shared/models/enums/size.enum';
import { ChannelAvatarComponent } from '../channel-avatar/channel-avatar.component';
import { timestampToDate } from '../chat.utils';
import { ChannelNamePipe } from '../pipes/channel-name.pipe';
import { ChannelSubtitlePipe } from '../pipes/channel-subtitle.pipe';

@Component({
  selector: 'pxc-channel-preview',
  imports: [
    CommonModule,
    ChannelAvatarComponent,
    ChannelSubtitlePipe,
    TuiBadge,
    TuiCell,
    TuiTitle,
    ChannelNamePipe,
    TuiLineClamp,
  ],
  templateUrl: './channel-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChannelPreviewComponent implements OnChanges {
  private readonly authenticationService = inject(AuthenticationService);

  @Input() channel: Channel;
  @Input() size: Size = Size.SMALL;
  @Input() showDetails = true;
  @Input() vertical = false;

  Size = Size;

  unreadsCount = 0;
  date: Date;

  ngOnChanges(): void {
    this.unreadsCount = this.channel.unreads[this.authenticationService.user.id];
    this.date = timestampToDate(this.channel.lastMessage?.createdOn);
  }
}
